import React from 'react';
import { Check } from 'lucide-react';
import Reveal from './Reveal';
import { PRICES } from '../config/site';
import { FREE, PRO } from '../data/plans';

/**
 * Free vs Pro, as decided in BELL_CLUB_BUILD.md §1. A crew is free to JOIN,
 * so a Pro member can always bring a friend; creating one is Pro. Every
 * price comes from config/site.js - none is spelled in this file. The trial
 * is on the yearly plan (owner, 2026-10-17).
 */
const Ticks = ({ items }) => (
  <ul className="price-list">
    {items.map((f) => (
      <li key={f}>
        <Check size={18} strokeWidth={3} aria-hidden="true" />
        <span>{f}</span>
      </li>
    ))}
  </ul>
);

const Pricing = () => (
  <section id="pricing" className="section" aria-labelledby="pricing-headline">
    <div className="section-inner">
      <Reveal>
        <div className="section-head-center">
          <p className="eyebrow">Pricing</p>
          <h2 id="pricing-headline" className="h2">
            Free to start. Pro when you want more.
          </h2>
        </div>
        <div className="grid-2 pricing">
          <article className="panel price-card">
            <h3 className="h3">Free</h3>
            <p className="price">
              <span className="price-num">$0</span>
            </p>
            <p className="price-note">No card, no trial clock.</p>
            <Ticks items={FREE} />
          </article>
          <article className="panel price-card price-card-pro">
            <h3 className="h3">Bell Club Pro</h3>
            <p className="price">
              <span className="price-num">{PRICES.monthly}</span>
              <span className="price-per"> a month</span>
            </p>
            <p className="price-note">
              or {PRICES.yearly} a year, with a {PRICES.trialDays}-day free trial
            </p>
            <Ticks items={PRO} />
          </article>
        </div>
        <p className="small center fine-print">
          Prices in US dollars; the App Store shows the price in your currency. Pro is an in-app
          purchase through the App Store - there is no web checkout. It renews automatically unless
          you cancel at least 24 hours before the end of the current period, any time, in your
          iPhone's Settings → Apple Account → Subscriptions.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Pricing;
